// src/pages/productos.jsx
import React, { useEffect, useState } from "react";
import axios from "../api/axios";
import { useAuth } from "../context/AuthContext";

function Productos() {
  const [productos, setProductos] = useState([]);
  const [paginasTotales, setPaginasTotales] = useState(1);
  const [busqueda, setBusqueda] = useState("");
  const [pagina, setPagina] = useState(1);
  const { user } = useAuth();

  useEffect(() => {
    const fetchData = async () => {
      const res = await axios.get(
        `/api/busqueda/buscar?q=${busqueda}&page=${pagina}`
      );
      setProductos(res.data.productos);
      setPaginasTotales(res.data.paginasTotales);
    };
    fetchData();
  }, [busqueda, pagina]);

  return (
    <div className="w-full p-6 min-h-[calc(100vh-6rem)]">
      <h1 className="text-3xl font-bold mb-4">Buscar Productos</h1>

      <input
        type="text"
        className="w-full p-2 border border-secondary-900 text-black font-semibold rounded mb-4"
        placeholder="Buscar..."
        value={busqueda}
        onChange={(e) => {
          setBusqueda(e.target.value);
          setPagina(1);
        }}
      />

      <table className="w-full table-auto border-secondary-900">
        <thead className="bg-secondary-900">
          <tr>
            <th className="border px-4 py-2">Referencia</th>
            <th className="border px-4 py-2">SKU</th>
            <th className="border px-4 py-2">Descripción</th>
            <th className="border px-4 py-2">Marca</th>
            {user?.role === "admin" && (
              <td className="border px-4 py-2"> Precio Neto</td>
            )}
            <th className="border px-4 py-2">Precio Venta</th>
          </tr>
        </thead>
        <tbody>
          {Array.isArray(productos) && productos.length > 0 ? (
            productos.map((p) => (
              <tr key={p.sku} className="hover:bg-secondary-900">
                <td className="border px-4 py-2">{p.referencia}</td>
                <td className="border px-4 py-2">{p.sku}</td>
                <td className="border px-4 py-2">{p.descripcion}</td>
                <td className="border px-4 py-2">{p.marca}</td>
                {user?.role === "admin" && (
                  <td className="border px-4 py-2">{p.pvd} €</td>
                )}
                <td className="border px-4 py-2">{p.pvp} €</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="5" className="text-center py-4">
                No se encontraron productos
              </td>
            </tr>
          )}
        </tbody>
      </table>

      <div className="flex justify-between items-center mt-4">
        <button
          className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
          disabled={pagina === 1}
          onClick={() => setPagina(pagina - 1)}
        >
          Anterior
        </button>

        <span>
          Página {pagina} de {paginasTotales}
        </span>

        <button
          className="bg-blue-500 text-white px-4 py-2 rounded disabled:opacity-50"
          disabled={pagina >= paginasTotales}
          onClick={() => setPagina(pagina + 1)}
        >
          Siguiente
        </button>
      </div>
    </div>
  );
}

export default Productos;
